import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FinancialOffer } from '../models/financial-offer.model';
import { MplType } from '../../contract-flow/enums/mpl-type.enum';

interface CreateLoanAgreementRequest {
  submission_id: string;
  id: string;
  secret: string;
  data_request_id: string;
}

interface GetLoanAgreementRequest {
  pdf_hash: string;
  download_url: string;
  permanent_download_url: string;
  state: string;
}

export type LoanAgreementFields = {
  [key in 'signature' | 'signature2' | 'business_stamp' | 'business_stamp2']: {
    base64: string;
  };
};

@Injectable()
export class FinancialOfferService {
  constructor(private http: HttpClient) {}

  public get(contractGuid: string, mplType: MplType, requiredVisible: boolean = true): Observable<FinancialOffer[]> {
    const url = '/api/payment-contracts/{contractGuid}/{mplType}/financial-offerings';
    return this.http
      .get<{ items: FinancialOffer[] }>(url.replace('{contractGuid}', contractGuid).replace('{mplType}', mplType), {
        params: {
          required_visible: requiredVisible,
        },
      })
      .pipe(map((result) => result.items));
  }

  // TODO: find a better name for function
  public confirmFinancialOffer(contractGuid: string, financialOfferingGuid: string): Observable<any> {
    const approveFinancialOfferStatus = 2;
    const url = '/api/payment-contracts/contractGuid/financial-offerings/financialOfferingGuid';
    return this.http.put(url.replace('contractGuid', contractGuid).replace('financialOfferingGuid', financialOfferingGuid), {
      status: approveFinancialOfferStatus,
    });
  }

  public createLoanAgreement(
    contractGuid: string,
    financialOfferingGuid: string,
    sendDataRequests: boolean = true,
    fields?: LoanAgreementFields | null,
  ): Observable<CreateLoanAgreementRequest> {
    const url = '/api/payment-contracts/{contractGuid}/financial-offerings/{financialOfferingGuid}/loan-agreements';
    return this.http.post<CreateLoanAgreementRequest>(
      url.replace('{contractGuid}', contractGuid).replace('{financialOfferingGuid}', financialOfferingGuid),
      {
        send_data_requests: sendDataRequests,
        fields,
      },
    );
  }

  public getLoanAgreement(contractGuid: string, financialOfferingGuid: string, submissionId: string): Observable<GetLoanAgreementRequest> {
    const url = '/api/payment-contracts/contractGuid/financial-offerings/financialOfferingGuid/loan-agreements';
    return this.http.get<GetLoanAgreementRequest>(
      url.replace('contractGuid', contractGuid).replace('financialOfferingGuid', financialOfferingGuid) + '/' + submissionId,
    );
  }
}
